export const INTEGRATION_MODELS = Object.freeze({
  SHOPIFY: 'shopify',
  MDI: 'mdi',
  TELEGRAMD: 'telegramd',
  STRIPE: 'stripe',
  SLACK: 'slack',
  ONESIGNAL: 'onesignal',
  GMAIL_INBOX: 'gmail_inbox',
  HIGHLEVEL: 'highlevel',
  JUNCTION: 'junction',
  MAILGUN: 'mailgun',
  AGENT_SALE: 'agent_sale',
  LAB_REVIEW: 'lab_review',
  INTAKE: 'intake',
});

const DEFAULT_INTEGRATION_ACTIONS = {
  ACTIVE: 'active',
};

export const INTEGRATION_STRUCT = Object.freeze({
  SHOPIFY: { NAME: INTEGRATION_MODELS.SHOPIFY, ACTIONS: { ...DEFAULT_INTEGRATION_ACTIONS } },
  MDI: { NAME: INTEGRATION_MODELS.MDI, ACTIONS: { ...DEFAULT_INTEGRATION_ACTIONS } },
  TELEGRAMD: { NAME: INTEGRATION_MODELS.TELEGRAMD, ACTIONS: { ...DEFAULT_INTEGRATION_ACTIONS } },
  STRIPE: { NAME: INTEGRATION_MODELS.STRIPE, ACTIONS: { ...DEFAULT_INTEGRATION_ACTIONS } },
  SLACK: { NAME: INTEGRATION_MODELS.SLACK, ACTIONS: { ...DEFAULT_INTEGRATION_ACTIONS } },
  ONESIGNAL: { NAME: INTEGRATION_MODELS.ONESIGNAL, ACTIONS: { ...DEFAULT_INTEGRATION_ACTIONS } },
  GMAIL_INBOX: { NAME: INTEGRATION_MODELS.GMAIL_INBOX, ACTIONS: { ...DEFAULT_INTEGRATION_ACTIONS } },
  HIGHLEVEL: { NAME: INTEGRATION_MODELS.HIGHLEVEL, ACTIONS: { ...DEFAULT_INTEGRATION_ACTIONS } },
  JUNCTION: { NAME: INTEGRATION_MODELS.JUNCTION, ACTIONS: { ...DEFAULT_INTEGRATION_ACTIONS } },
  MAILGUN: { NAME: INTEGRATION_MODELS.MAILGUN, ACTIONS: { ...DEFAULT_INTEGRATION_ACTIONS } },
  AGENT_SALE: { NAME: INTEGRATION_MODELS.AGENT_SALE, ACTIONS: { ...DEFAULT_INTEGRATION_ACTIONS } },
  LAB_REVIEW: { NAME: INTEGRATION_MODELS.LAB_REVIEW, ACTIONS: { ...DEFAULT_INTEGRATION_ACTIONS } },
});
